export default __webpack_public_path__ + "static/media/cortag.48dc748a.png";